import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    urlIndex: '',
    simpleNoticeState:false,
    billIndex: window.sessionStorage.getItem("billIndex") == null ? (window.localStorage.getItem("billIndex") == null ? 2 : window.localStorage.getItem("billIndex")) : window.sessionStorage.getItem("billIndex"), //  账单 设置默认子类
    setTingIndex: window.sessionStorage.getItem("setTingIndex") == null ? (window.localStorage.getItem("setTingIndex") == null ? 2 : window.localStorage.getItem("setTingIndex")) : window.sessionStorage.getItem("setTingIndex"),
  },
  mutations: {
    urlIndex(state, payload) {
      state.urlIndex = payload
    },
    billIndex(state, payload) {
      state.billIndex = payload
    },
    setTingIndex(state, payload) {
      state.setTingIndex = payload
    },
    setSimpleNoticeVal(state, payload) {
      state.simpleNoticeState = payload
    },
  },
  actions: {
  },
  modules: {
  }
})
